<template>
  <div class="payable-now-and-balance">
    <section class="cost-section now">
      <table class="totals">
        <tbody>
          <tr>
            <td>
              <translate class="amount" tag="h4"> Payable now </translate>
            </td>
            <td class="amount">
              <pu-price :price="deposit" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <td colspan="2">
              <translate tag="p" :tt="{ depositPercent }">
                This is a {depositPercent, number, percent} non-refundable
                deposit.
              </translate>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="cost-section later">
      <table class="totals">
        <tbody>
          <tr class="balance">
            <td>
              <translate class="amount" tag="h4"> Balance </translate>
            </td>
            <td class="amount">
              <pu-price :price="remainder" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <td colspan="2">
              <translate
                v-if="campsitePaymentTiming === 'arrive'"
                :tt="{ campsiteName }"
              >
                The remainder is payable direct to {campsiteName} on arrival.
              </translate>
              <translate v-else-if="balanceDueDate" :tt="{ balanceDueDate }">
                The remainder is payable directly to the site by
                {balanceDueDate, puDate, short}.
              </translate>
              <translate v-else>
                The remainder is payable directly to the site as soon as
                possible.
              </translate>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>
<script lang="ts">
import type { PaymentTiming } from '../../../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { SimpleMoney } from '~/utility/money'

@Component
class StripePaymentPitchupOnly extends Vue {
  @Prop()
  campsiteName: string

  @Prop()
  balanceDueDate: string

  @Prop({ required: true, type: String })
  campsitePaymentTiming: PaymentTiming

  @Prop()
  deposit: SimpleMoney

  @Prop()
  remainder: SimpleMoney

  @Prop()
  depositPercent: number
}

export default toNative(StripePaymentPitchupOnly)
</script>
